export default {
    methods: {
        clearError() {
            this.$store.commit('setError', null);
        }
    }
}